import { BaseError, createErrorBuilder } from '@wix/public-editor-platform-errors';
export let EditorPlatformManifestServicesErrorCode = /*#__PURE__*/function (EditorPlatformManifestServicesErrorCode) {
  EditorPlatformManifestServicesErrorCode["ComponentNotExistsInEERegistry"] = "Component doesn't exist in EE Registry";
  EditorPlatformManifestServicesErrorCode["LoadManifestFromCDNError"] = "Can't load manifest from CDN";
  EditorPlatformManifestServicesErrorCode["ManifestUrlNotProvided"] = "Manifest URL not provided";
  EditorPlatformManifestServicesErrorCode["MultipleManifestsLoadingFailed"] = "Multiple manifests loading failed";
  EditorPlatformManifestServicesErrorCode["MultipleManifestsResolvingFailed"] = "Multiple manifests resolving failed";
  EditorPlatformManifestServicesErrorCode["FailedToResolveManifest"] = "Failed to resolve manifest";
  EditorPlatformManifestServicesErrorCode["NoSuchHandlerToGetManifestData"] = "There is no such handler for retrieving root manifest data";
  EditorPlatformManifestServicesErrorCode["CanNotGetManifestByInnerElPath"] = "Can't get element manifest by inner element path";
  EditorPlatformManifestServicesErrorCode["ThereIsNoManifestForComp"] = "There is no manifest for the component";
  return EditorPlatformManifestServicesErrorCode;
}({});
class EditorPlatformManifestServicesError extends BaseError {
  constructor(message, code) {
    super(message, code, 'Editor Platform Manifest Services Error');
  }
  withMultipleErrors(errors) {
    this.state = {
      ...this.state,
      errors: errors.map(error => error.message).join(', ')
    };
    return this;
  }
  withComponentType(componentType) {
    this.state = {
      ...this.state,
      componentType
    };
    return this;
  }
  withInnerElementPath(elementPath) {
    const innerElementPath = elementPath ? elementPath.join(' ') : '';
    this.state = {
      ...this.state,
      innerElementPath
    };
    return this;
  }
}
export const createEditorPlatformManifestServicesError = createErrorBuilder(EditorPlatformManifestServicesError);
//# sourceMappingURL=errors.js.map